import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import QaSuperUser from "../components/qa_super_user/QaSuperUser";
import createErrorBoundary from "shared/components/wrappers/errorBoundary";

const mapStateToProps = (state) => ({
  currentContractor: state.currentContractor,
});

const mapDispatchToProps = (dispatch) => ({});

export default createErrorBoundary()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(QaSuperUser))
);
